import { IPublicClientApplication } from '@azure/msal-browser';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  deleteAwardJudge,
  deleteCountryAwardJudge,
  updateAwardJudgeStatus,
  updateCountryAwardJudgeStatus,
} from './index';

export const createStaffAwardJudgesApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  deleteAwardJudge: (instance: IPublicClientApplication, awardJudgeId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteAwardJudge(fetchContext, awardJudgeId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteAwardJudge', isInFlight);
    },
  ),
  deleteCountryAwardJudge: (instance: IPublicClientApplication, awardJudgeId: number, countryId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteCountryAwardJudge(fetchContext, awardJudgeId, countryId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteCountryAwardJudge', isInFlight);
    },
  ),
  updateAwardJudgeStatus: (instance: IPublicClientApplication, awardJudgeId: number, status: boolean) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateAwardJudgeStatus(fetchContext, awardJudgeId, status, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateAwardJudgeStatus', isInFlight);
    },
  ),
  updateCountryAwardJudgeStatus: (instance: IPublicClientApplication, awardJudgeId: number, countryId: number, status: boolean) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateCountryAwardJudgeStatus(fetchContext, awardJudgeId, countryId, status, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateCountryAwardJudgeStatus', isInFlight);
    },
  ),
});
